(function () {
  'use strict';

  var body = document.body;
  if (!body || (!body.classList.contains('template-collection') && !body.classList.contains('template-search'))) return;

  var storageKey = 'avo_listing_position';
  var pageKey = window.location.pathname + window.location.search;
  var productSelector = '#MainContent a[href*="/products/"]';

  function savePosition(link) {
    try {
      var productUrl = new URL(link.href, window.location.origin);
      sessionStorage.setItem(storageKey, JSON.stringify({
        page: pageKey,
        product: productUrl.pathname,
        y: window.scrollY,
        savedAt: Date.now()
      }));
    } catch (error) {}
  }

  document.addEventListener('click', function (event) {
    var link = event.target.closest(productSelector);
    if (link) savePosition(link);
  }, true);

  function readPosition() {
    try {
      var saved = JSON.parse(sessionStorage.getItem(storageKey) || 'null');
      if (!saved || saved.page !== pageKey || Date.now() - saved.savedAt > 1800000) return null;
      return saved;
    } catch (error) {
      return null;
    }
  }

  function restorePosition() {
    var saved = readPosition();
    if (!saved) return;

    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      var matchingLink = Array.prototype.find.call(
        document.querySelectorAll(productSelector),
        function (link) {
          try {
            return new URL(link.href, window.location.origin).pathname === saved.product;
          } catch (error) {
            return false;
          }
        }
      );

      var maximumY = Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
      window.scrollTo(0, Math.min(saved.y, maximumY));

      if (matchingLink && maximumY >= saved.y - 20) {
        window.scrollTo(0, saved.y);
        window.clearInterval(timer);
        sessionStorage.removeItem(storageKey);
        return;
      }

      var loadMore = document.querySelector('[data-load-more][href]:not(.is--loading)');
      if (loadMore && attempts % 2 === 0) loadMore.click();

      if (attempts >= 30) {
        window.clearInterval(timer);
        window.scrollTo(0, Math.min(saved.y, maximumY));
      }
    }, 300);
  }

  window.addEventListener('pageshow', function () {
    window.setTimeout(restorePosition, 50);
  });
})();
